module.exports = __webpack_public_path__ + "media/images/social-media/social-image-e2d3c3f4813f12bfd11ccd7eaa4c8a56.jpg";